<template>
  <div class="content d-flex-right">
    <div class="header">
      <div style="margin: 5px 0">
        <div>
          <SelectCdjProjectHeader :items="['type_id','place_id','region_id','project_id']" @onHeader="onHeader">
            <el-select placeholder="账龄类型" clearable v-model="reginWhere.age" size="mini">
<!--              <el-option :value="1" label="当期"></el-option>-->
<!--              <el-option :value="2" label="纯上一年"></el-option>-->
              <el-option :value="3" label="1年以上2年以内"></el-option>
              <el-option :value="4" label="2年以上"></el-option>
            </el-select>
            <el-select v-model="where.thrid_company_id" class="m-2" filterable placeholder="选择合作单位" clearable size="mini">
              <el-option
                v-for="item in thrid_company_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-date-picker
              style="width: 150px"
              v-model="where.start_time"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </SelectCdjProjectHeader>
        </div>
      </div>
    </div>

    <div class="body">
      <el-tabs type="border-card" v-model="card_index">
<!--        <el-tab-pane label="第三方申请" name="ThirdPartyLegalMainPlan">-->
<!--          <ThirdPartyLegalMainPlan v-if="card_index==='ThirdPartyLegalMainPlan'" :urge_type="4"  />-->
<!--        </el-tab-pane>-->
        <el-tab-pane label="催费跟进" name="ThirdpartyLitigationLayout">
          <ThirdpartyLitigationLayout v-if="card_index==='ThirdpartyLitigationLayout'" />
        </el-tab-pane>
<!--        <el-tab-pane label="资料完整" name="LegalHouseCustomer">-->
<!--          <LegalHouseCustomer v-if="card_index==='LegalHouseCustomer'" :urge_type="4" />-->
<!--        </el-tab-pane>-->
        <el-tab-pane label="资料管理" name="LegalHouseCustomer">
          <CaseDocumentsManager v-if="card_index==='LegalHouseCustomer'" case-type="third" :project_type="project_type"/>
        </el-tab-pane>
        <el-tab-pane label="移交记录" name="ThirdPartyLitigationLegalHandoverRecord">
          <ThirdPartyLitigationLegalHandoverRecord v-if="card_index==='ThirdPartyLitigationLegalHandoverRecord'" :urge_type="4" />
        </el-tab-pane>
        <el-tab-pane label="登记数据" name="ThirdPartyLitigationListLayout">
          <ThirdPartyLitigationListLayout v-if="card_index==='ThirdPartyLitigationListLayout'&&is_loading" />
        </el-tab-pane>
        <el-tab-pane label="合作单位催缴统计" name="ThirdPartyLitigationCompanyProjectLayout">
<!--          <ThirdPartyLitigationCompanyProject v-if="card_index==='ThirdPartyCompanyProject'" :urge_type="4" />-->
          <ThirdPartyLitigationCompanyProjectLayout v-if="card_index==='ThirdPartyLitigationCompanyProjectLayout'" />
        </el-tab-pane>
        <el-tab-pane label="合作单位管理" name="CooperativeLayout">
<!--          <ThirdPartyLitigationCooperativeEnterprise v-if="card_index==='ThirdPartyCooperativeEnterprise'" />-->
          <CooperativeLayout v-if="card_index==='CooperativeLayout'" :urge_type="4"/>
        </el-tab-pane>
        <el-tab-pane label="第三方诉讼状态统计表" name="RecordFilingStatusStatisticsTable">
          <RecordFilingStatusStatisticsTable v-if="card_index==='RecordFilingStatusStatisticsTable'" type="2" />
        </el-tab-pane>

        <el-tab-pane label="操作流程指引图" name="flow_img">
          <template slot="label">
            <span style="font-weight: bold;color: #F56C6C;">操作流程指引图</span>
          </template>
          <el-image style="width: 100%;height: 65vh;"
                    fit="contain"
                    src="https://api.oa.gdzawy.com:9001/legal_img/dsf_img.png"
                    :preview-src-list="['https://api.oa.gdzawy.com:9001/legal_img/dsf_img.png']"
          ></el-image>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import ThirdPartyLitigationListLayout from "./components/thirdparty_litigation/ThirdPartyLitigationListLayout";
import ThirdPartyLitigationCooperativeEnterprise from "./components/thirdparty_litigation/ThirdPartyLitigationCooperativeEnterprise";
import ThirdPartyLitigationCompanyProject from "./components/thirdparty_litigation/ThirdPartyLitigationCompanyProject";
import ThirdPartyLitigationLegalHandoverRecord from "./components/thirdparty_litigation/ThirdPartyLitigationLegalHandoverRecord";
import AgingType from "./components/common/AgingType";
import ThirdPartyLegalMainPlan from "./components/plan/ThirdPartyLegalMainPlan";
import RecordFilingStatusStatisticsTable from "./components/report_forms/RecordFilingStatusStatisticsTable";
import LegalHousePlanUnit from "./components/plan/LegalHousePlanUnit";
import ButlerHttp from "./common/ButlerHttp";
import ThirdpartyLitigationLayout from "./components/thirdparty_litigation/ThirdpartyLitigationLayout";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";
import ThirdPartyLitigationCompanyProjectLayout
  from "./components/thirdparty_litigation/ThirdPartyLitigationCompanyProjectLayout";
import CooperativeLayout from "./components/thirdparty_common/CooperativeLayout";
import LegalHouseCustomer from "./components/plan/LegalHouseCustomer";
import CaseDocumentsManager from "./components/CaseDocumentsManager.vue";

export default {
  name: "ThirdPartyLitigation",
  components: {
    LegalHouseCustomer,
    CooperativeLayout,
    ThirdPartyLitigationCompanyProjectLayout,
    SelectCdjProjectHeader,
    ThirdpartyLitigationLayout,
    LegalHousePlanUnit,
    RecordFilingStatusStatisticsTable,
    ThirdPartyLegalMainPlan,
    AgingType,
    ThirdPartyLitigationCompanyProject,
    ThirdPartyLitigationCooperativeEnterprise,
    ThirdPartyLitigationListLayout,
    ThirdPartyLitigationLegalHandoverRecord,
    CaseDocumentsManager},
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data(){
    return{
      is_loading:false,
      where: {
        text:"",
        is_authentication:"",
        thrid_company_id:"",
        start_time:moment(new Date()).format("YYYY-MM"),
        end_time:moment(new Date()).format("YYYY-MM"),
      },
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[],
        age:"",
        level:0
      },
      card_index:"ThirdpartyLitigationLayout",
      project_type: 1,
      thrid_company_list:[]
    }
  },
  activated() {
    const that=this;
    that.getThridCompanyList();
    if(that.$route.query.card_index){
      that.card_index=that.$route.query.card_index
    }
  },
  methods:{
    getThridCompanyList(){
      const that = this;
      ButlerHttp.post("ThirdPartyLitigation/getCollectionThridCompanyList", {
        status: 1,
        page: 1,
        page_size: 300
      }, res => {
        if (res.code) {
          that.thrid_company_list = res.data.list;
        }
      });
    },
    exportExcelNote(){
      const that = this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("ThirdPartyLitigation/exportExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
      if(this.reginWhere.type_id == 4 || this.reginWhere.type_id == 3 || this.reginWhere.type_id == 5){
        that.project_type = 2;  // 撤场项目
      }else{
        that.project_type = 1;  // 在管项目
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";
.content{
  padding: 10px;
  margin-left: 10px;

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ThirdPartyLitigation.vue